module.exports = __webpack_public_path__ + "img/erweima.4784d25c.png";